import { bindActionCreators, Dispatch } from 'redux';
// import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { IApplicationState } from 'ducks/reducers';
import { selectors as customerSelectors } from 'ducks/customer';
import { actions as transactionActions } from 'ducks/customerEnquiry/transactions';
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup';
import { selectors as staffSelectors } from 'ducks/staff';
import EnquiryGrid from './EnquiryGrid';

const mapStateToProps = (state: IApplicationState) => ({
  selectedCustomer: customerSelectors.selected(state),
  selectedProduct: productSelectors.selected(state),
  defaultView: staffSelectors.staff(state)?.defaultView
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    setSelectedTransactionLine: transactionActions.setSelected,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryGrid);
